//npm i zoomist
import Zoomist from 'zoomist';
import { ready } from "./utils.js";

// import Zoomist styles
import 'zoomist/css';



// initialize

var classElements = document.getElementsByClassName("zoomist-container");
if (classElements.length > 0 ) {

  const zoomist = new Zoomist('.zoomist-container', {
    maxScale: 4,
    zoomer: true,
    wheelable: false //Scrollrad deaktivieren. Wunsch Mail vom 25. April 2025.
  });

};